import { EntityKey } from '@feature/pma-entity/pma-entity-types';
import { Action, createReducer, on } from '@ngrx/store';
import * as EntityKeyServiceActions from '../actions/entity-key.actions';

export interface State {
    entityKey : EntityKey
}

export const initialState: State = {
    entityKey : undefined
};

const EntityKeyServiceReducer = createReducer(
    initialState,
    on(EntityKeyServiceActions.EntityKeyUpdated, (state, { entityKey }) => ({ entityKey: entityKey }))
  );
  
  export function reducer(state: State | undefined, action: Action) {
    return EntityKeyServiceReducer(state, action);
  }